import axios from 'axios';

import { ResponseObj, ConvitePacienteFormData, ConvitePacienteQueryObj } from '../../../back/src/types';
import { ConvitePaciente } from '../../../back/src/entity/ConvitePaciente';

const buscaConvitePaciente = async (
  queryObj: ConvitePacienteQueryObj = {},
): Promise<ResponseObj<ConvitePaciente>> => {
  const res = await axios.get<ResponseObj<ConvitePaciente>>(
    'convites_pacientes/buscar',
    { params: queryObj },
  );
  return res.data;
};

const criaConvitePaciente = async (
  formData: ConvitePacienteFormData,
): Promise<ResponseObj<ConvitePaciente>> => {
  const res = await axios.post<ResponseObj<ConvitePaciente>>('convites_pacientes', formData);
  return res.data;
};

const reenviaConvitePaciente = async (
  conviteId: number,
): Promise<ResponseObj<ConvitePaciente>> => {
  const res = await axios.put<ResponseObj<ConvitePaciente>>(`convites_pacientes/${conviteId}/reenviar`);
  return res.data;
};

export default {
  buscaConvitePaciente,
  criaConvitePaciente,
  reenviaConvitePaciente,
};
